/* eslint-disable no-return-await */
import PropTypes from 'prop-types';
import {useEffect, useRef} from 'react';
import doMetric from '../../../v2/tracking/bigQueryMetricRecorder';
import DomUtils from '../../../v2/utils/DomUtils';
import Track from '../../../v2/utils/tracking';

export function Rokt(props) {
  const loadedRokt = useRef(false);
  
  const enableRoktJS = async () => {
    await new Promise((resolve) => {
      if (window.Rokt) {
        resolve();
      } else {
        document.getElementById('rokt-launcher').onload = resolve;
      }
      
      return window.Rokt;
    });
  };
  
  const createLauncher = async () => await window.Rokt.createLauncher({
    accountId: props.roktId,
    noFunctional: !props.consentedToTargetingPrivacyConsentGroups,
    noTargeting: !props.consentedToTargetingPrivacyConsentGroups,
  });
  
  const attributes = {
    country: props.countryCode,
    locale: props.locale,
    confirmationref: props.orderNumber,
    firstNameEnc: props.encryptedValues?.firstNameEnc,
    lastNameEnc: props.encryptedValues?.lastNameEnc,
    emailEnc: props.encryptedValues?.emailEnc,
    mobileEnc: '',
  };
  
  const getSelection = async launcher => await launcher.selectPlacements({
    attributes,
  });
  
  useEffect(() => {
    if (!loadedRokt.current) {
      DomUtils.addScript(
        'https://apps.rokt.com/wsdk/integrations/launcher.js',
        true,
        '',
        'high',
        true,
        'rokt-launcher',
      ).then(() => {
        loadedRokt.current = true;
        
        try {
          doMetric('Rokt', [{name: 'loaded', value: true}], [], 'impression');
        } catch (error) {
          Track.track(error);
        }
        
        enableRoktJS().then(() => {
          createLauncher().then((launcher) => {
            getSelection(launcher).then(((selection) => {
              selection.on('POSITIVE_ENGAGEMENT').subscribe(() => {
                selection.setAttributes({...attributes});
              });
            }));
          });
        }).catch(e => Track.error(`Error using ROKT script. ${e}`));
      }).catch(e => Track.error(`Error laoding ROKT script. ${e}`));
    }
  }, [props.orderNumber, props.roktEnabled, loadedRokt, props.locale, props.countryCode, props.roktId,
    props.encryptedValues.firstNameEnc, props.encryptedValues.lastNameEnc, props.encryptedValues.emailEnc]);
  
  return <div id="rokt-placeholder" data-cs-mask />;
}

Rokt.propTypes = {
  roktEnabled: PropTypes.bool,
  roktId: PropTypes.string,
  orderNumber: PropTypes.string,
  countryCode: PropTypes.string,
  locale: PropTypes.string,
  encryptedValues: PropTypes.shape({
    firstNameEnc: PropTypes.string,
    lastNameEnc: PropTypes.string,
    emailEnc: PropTypes.string,
  }),
};

export default Rokt;
